// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-contaier[data-v-8b36947c]{position:relative}.modal-contaier .close-btn[data-v-8b36947c]{position:absolute;right:12px;top:12px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
